import { Link, useLocation } from 'react-router-dom';
import { ArrowUpRight, Clock } from '@phosphor-icons/react';
import { applianceLabel, type Recipe, totalMinutes } from '../lib/recipes';

export function RecipeCard({ recipe }: { recipe: Recipe }) {
  const location = useLocation();
  return <article className="recipe-card">
    <Link className="recipe-card-link" to={`/recipes/${recipe.slug}/`} state={{ from: location.pathname + location.search }}>
      <div className="recipe-card-image"><img src={recipe.image} alt={recipe.imageAlt} loading="lazy" width="1200" height="900" />{recipe.illustrative && <span className="illustration-label">Ảnh minh họa</span>}</div>
      <div className="recipe-card-body"><div className="card-meta"><span>{applianceLabel(recipe.appliance)}</span><span><Clock size={14} />{totalMinutes(recipe)} phút</span></div><h3>{recipe.title}</h3><p>{recipe.summary}</p><span className="card-link-label">Xem công thức <ArrowUpRight size={19} /></span></div>
    </Link>
  </article>;
}
